import {MathUtils} from "../../../../utils/math/MathUtils";

export const getPagedData = <T>(data: T[], currentPage: number, itemsPerPage: number) => {
	let pagedData = data;
	let startIndex = 0;
	let lastIndex = data.length - 1;
	const clampedCurrentPage = MathUtils.clamp(currentPage, 0, Math.ceil(data.length / itemsPerPage) - 1);

	if (itemsPerPage > 0) {
		startIndex = clampedCurrentPage * itemsPerPage;

		if (data.length !== 0) {
			lastIndex = startIndex + itemsPerPage - 1;
			lastIndex = Math.min(data.length - 1, lastIndex);
		} else {
			lastIndex = 0;
		}

		pagedData = data.slice(startIndex, lastIndex + 1);
	}

	return {
		clampedCurrentPage,
		pagedData,
		startIndex: startIndex,
		lastIndex: lastIndex,
	};
};
